var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 36C11.16 36 4 28.84 4 20C4 11.16 11.16 4 20 4C28.84 4 36 11.16 36 20C36 28.84 28.84 36 20 36Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0902 14.8201C27.0902 14.8701 27.0902 14.9201 27.0802 14.9701L25.1202 26.9801C25.0702 27.3001 24.8902 27.5701 24.6202 27.7501C24.2402 28.0001 23.7502 27.9901 23.3702 27.7401L17.8702 24.0501C17.4702 23.7801 17.4202 23.2201 17.7702 22.8901L22.8302 18.0701C22.9302 17.9701 22.9602 17.8201 22.8802 17.6901C22.7902 17.5401 22.5902 17.4901 22.4502 17.5901L15.7302 22.0001C14.9802 22.4901 14.0502 22.6201 13.1902 22.3601L10.6502 21.5601C10.3802 21.4801 10.2002 21.2301 10.2002 20.9501C10.2002 20.8201 10.2402 20.7001 10.3102 20.6001C10.3802 20.5001 10.4702 20.4201 10.5902 20.3601L25.7102 13.9001C26.1002 13.7401 26.5502 13.8401 26.8302 14.1501C27.0002 14.3401 27.0902 14.5801 27.0902 14.8201Z",
    fill: "#72BF44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.d4c7b5a0ddb7fd65e4c5a5ac51eb4cd9.svg";
export { ForwardRef as ReactComponent };